module.exports = __webpack_public_path__ + "f6ecc3887ad1d6a7b8e3b8197fb2b2bb.png";